var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"controlRef",staticClass:"el-segmented"},[_c('div',{staticClass:"el-segmented-controls"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }